<template>
  <div>
    <!-- light-row
    @row-select="x=>$emit('change',x)"-->
    <list
      row-key="Id"
      ref="list"
      unit="供应商对账单"
      :page="page"
      :queryParamsAppend="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getListChkPay"
      @selectClick="selectClick"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="供应商名称">
          <el-select v-model="params.TradeUnitId" clearable filterable placeholder="请选择" remote :remote-method="remoteMethod" @change="pitchOn">
            <el-option v-for="items in options" :key="items.value" :label="items.label" :value="items.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账周期">
          <el-select v-model="params.Cycle" @change="cycleChange">
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账期间">
          <el-date-picker
            @change="monthrangeChange"
            v-model="value"
            value-format="yyyy-MM-dd"
            style="width: 180px"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <!-- 后面补充 -->
    <!-- <supplier ref="supplier" selectable @select="setTradeunit" /> -->
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import tableColumn from '@/data/finance/dealings/supplierbill/list.json'
import tableParam from '@/data/finance/dealings/supplierbill/query.json'
// import supplier from "@/components/purchase/supplier/listDialog";

export default {
  mixins: [listMixin],
  components: {
    list
    // supplier
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/rp/rpPayDoc').default,
      getApi: require('@/api/ba/tradeUnit').default,
      payApi: require('@/api/rp/pay').default,
      value: '',
      params: {
        DocNo: '',
        Cycle: '',
        BusinessTypes: null,
        TradeUnitId: null,
        TradeUnitName: '',
        TradeUnitTypes: [1, 2, 3],
        DocDateStart: null,
        DocDateEnd: null
      },
      isMB: this.$store.state.isMB,
      options: []
    }
  },
  mounted() {
    this.remotemethodbtn()
    if (!this.$permission.canPrice('/finance/dealings/supplierbill')) {
      const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == 'NeedAmount')
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1)
      const findIndex1 = this.$refs.list.tableList.findIndex(item => item.tableName == 'AlreadyAmount')
      if (findIndex1 >= 0) this.$refs.list.tableList.splice(findIndex1, 1)
      const findIndex2 = this.$refs.list.tableList.findIndex(item => item.tableName == 'LeftAmount')
      if (findIndex2 >= 0) this.$refs.list.tableList.splice(findIndex2, 1)
    }
  },
  methods: {
    onExport() {
      var list = this.$refs.list
      var listParams = list.tempQueryParams
      var fields = list.tableList.map(x => x.tableName)
      var params = { ...listParams, Fields: fields.join(',') }
      // console.log('onExport', params);
      var loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api.getListChkPayExport(params).then(res => {
        loading.close()
      })
    },
    toURL(o) {
      this.$router.push(o)
    },
    selectClick(row) {
      console.log('row', row)
      if (row.SrcVouTypeName === '进货单') {
        let data = {
          DocId: row.SourceId
        }
        this.$router.push({
          name: 'editStock',
          params: { mode: 'edit', data }
        })
      }
      if (row.SrcVouTypeName === '加工费用单') {
        let data = {
          OutPocCostId: row.SourceId
        }
        this.$router.push({
          name: 'editMachiningCost',
          params: { mode: 'edit', data }
        })
      }
      if (row.SrcVouTypeName === '其它应付单') {
        let data = {
          OtherPayId: row.SourceId
        }
        this.$router.push({
          name: 'editOtherDeal',
          params: { mode: 'edit', data }
        })
      }
      if (row.SrcVouTypeName === '费用单') {
        let data = {
          DocId: row.SourceId
        }
        this.$router.push({
          name: 'editCost',
          params: { mode: 'edit', data }
        })
      }
      if (row.SrcVouTypeName === '冲销单') {
        this.$router.push({
          name: 'chargeoff',
          params: { DocNo: row.SourceNo }
        })
      }

      if (row.SrcVouTypeName === '付款单') {
        let id = row.SourceId
        this.payApi.info(id).then(res => {
          if (res.Code === 0) {
            this.toURL({
              name: 'editpayment',
              params: {
                type: 'edit',
                data: res.Data
              }
            })
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      }
    },
    monthrangeChange(t) {
      this.params.DocDateStart = t[0]
      var str = t[1].slice(5, 7)
      var year = t[1].slice(0, 4)
      var lastDate = new Date(year, str, 0).getDate()
      this.params.DocDateEnd = year + '-' + str + '-' + lastDate
    },
    pitchOn(val) {
      if (val) {
        this.remotemethodbtn()
      }
    },
    remoteMethod(val) {
      this.remotemethodbtn(val)
    },
    remotemethodbtn(val = '') {
      let params = {}
      params.FullName = val
      //params.pageIndex = 1
      //params.pageSize = 10
      params.TradeUnitTypes = [1, 2, 3]
      this.getApi.list(params).then(res => {
        if (res.Code == 0) {
          this.options = res.Data.map(el => {
            return { label: el.FullName, value: el.TradeUnitId }
          })
        }
      })
    },
    // openTradeunit() {
    //   this.$refs.supplier.open().then((that) => {
    //     that.getData();
    //   });
    // },
    // setTradeunit(data) {
    //   this.params.TradeUnitId = data.TradeUnitId;
    //   this.params.TradeUnitName = data.FullName;
    // },
    cycleChange(t) {
      var today = this.$commonJs.getToday()
      var start = ''
      var end = ''
      switch (t) {
        case '今天':
          start = today
          end = today
          break
        case '昨天':
          start = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          end = start
          break
        case '近3天':
          start = this.$dayjs().subtract(2, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近7天':
          start = this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近14天':
          start = this.$dayjs().subtract(13, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '本周':
          start = this.$dayjs().startOf('week').format('YYYY-MM-DD')
          end = today
          break
        case '上周':
          var week = this.$dayjs().subtract(1, 'week')
          start = week.startOf('week').format('YYYY-MM-DD')
          end = week.endOf('week').format('YYYY-MM-DD')
          break
        case '本月':
          start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
          end = today
          break
        case '上月':
          var month = this.$dayjs().subtract(1, 'month')
          start = month.startOf('month').format('YYYY-MM-DD')
          end = month.endOf('month').format('YYYY-MM-DD')
          break
        case '本季':
          start = this.$dayjs().startOf('quarter').format('YYYY-MM-DD')
          end = today
          break
        case '上季':
          var quarter = this.$dayjs().subtract(1, 'quarter')
          start = quarter.startOf('quarter').format('YYYY-MM-DD')
          end = quarter.endOf('quarter').format('YYYY-MM-DD')
          break
        case '本年':
          start = this.$dayjs().startOf('year').format('YYYY-MM-DD')
          end = today
          break
        case '上年':
          var year = this.$dayjs().subtract(1, 'year')
          start = year.startOf('year').format('YYYY-MM-DD')
          end = year.endOf('year').format('YYYY-MM-DD')
          break
      }
      this.params.DocDateStart = start
      this.params.DocDateEnd = end
      this.query()
    }
  }
}
</script>
